import React, { useEffect, useState } from "react";
import Sidebar from "../layouts/sidebar";
import WindowHead from "../layouts/windowHead";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DataTable from "react-data-table-component";
import PCusers from "../layouts/pc-users";
import PCcat1 from "../layouts/pc-cat1";
import PCcat2 from "../layouts/pc-cat2";
import PCcat3 from "../layouts/pc-cat3";
import PCcat4 from "../layouts/pc-cat4";


export default function UrlAnalytics() {

    const [showNav, setShowNav] = useState(false);

    const [items, setItems] = useState([]);
    const [count, setCount] = useState([]);

    useEffect(() => {
        fetchData();
        pieData();
    }, [])

    const fetchData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get_analytics_hits_per_ip`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("tokenn"),
                },
            });
            const result = await response.json();
            if (response.status === 200) {
                setItems(result?.data?.result || []);
            } else {
                toast.error(result?.error || 'An error occurred');
            }
        } catch (error) {
            toast.error(error?.message || 'No top hits found!');
        }
    };

    const pieData = () => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/get_analytics_url_categorywise_chart`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: localStorage.getItem("tokenn")
                }
            }
        )
            .then(res => res.json())
            .then(
                (result) => {
                    setCount(result?.data);
                },
                (error) => {
                    console.log(error);
                    setCount([]);
                }
            )
    }


    const columns = [
        {
            name: 'S. No.',
            selector: (_, index) => index + 1,
            width: '100px',
        },
        {
            name: 'IP',
            selector: (row) => row.Ip,
            // width: '140px',
        },
        {
            name: 'Count',
            selector: (row) => row.count,
            // width: '240px',
        },
        {
            name: 'Percentage',
            selector: (row) => row.percentage,
            // width: '240px',
        },
    ]



    return (
        <>
            <ToastContainer />
            <div className="bg-inner">
                <Sidebar show={showNav} onClose={() => setShowNav(false)} />
                <div className="d-flex flex-column ms-0 ms-xxl-3 col-12 col-sm-12 col-xxl-9">
                    <WindowHead sidebarOpen={() => setShowNav(!showNav)} />
                    <div className="main-content">
                    <div className="mb-3">
                            <h4 className="m-0">URL Analytics</h4>
                            <p>Track & Analyze data-driven insights for your URLs.</p>
                        </div>
                        <div className="uploaded_items">
                            <div className="d-lg-flex align-items-center mb-4 mb-lg-0">
                                <div className="pmain">
                                    <h5 style={{ color: "#6e6f72" }}>Users Overview</h5>
                                    <PCusers />
                                </div>
                                <div className="pcont mt-sm-2 mt-md-0">
                                    <h5 style={{ color: "#6e6f72" }}>URL Summary</h5>
                                    {count && count.length > 0 ? (
                                        <div className="w-100 d-flex align-items-center row">
                                            {count.length >= 1 && <PCcat1 data={count} />}
                                            {count.length >= 2 && <PCcat2 data={count} />}
                                            {count.length >= 3 && <PCcat3 data={count} />}
                                            {count.length >= 4 && <PCcat4 data={count} />}
                                        </div>
                                    ) : (
                                        <div style={{ padding: '10px', textAlign: 'center', width: '100%' }}>
                                            No Data Available
                                        </div>
                                    )}

                                </div>
                            </div>
                            <h5 style={{ color: "#6e6f72" }}>Top Clicks</h5>
                            <DataTable
                                className="custom_tborder"
                                columns={columns}
                                data={items}

                                fixedHeader
                                fixedHeaderScrollHeight="440px"
                                selectableRowsHighlight
                                highlightOnHover
                                noDataComponent={<div style={{ padding: '20px', textAlign: 'center' }}>No Records Available</div>} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}